import { Box, CircularProgress, Modal } from "@mui/joy";
import DarkTypography from "../../../../common/DarkTypography";
import { colorTokens, withAlpha } from "../../../../../styles/globalStyles";

type SummaryLoadingViewProps = {
  open: boolean;
  onClose: () => void;
};

export default function SummaryLoadingView({ open, onClose }: SummaryLoadingViewProps) {
  return (
    <Modal open={open} onClose={onClose} disableScrollLock keepMounted={false}>
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90vw", sm: 420 },
          minHeight: 220,
          borderRadius: "10px",
          backgroundColor: colorTokens.bg.sheetLight,
          color: colorTokens.text.inverse,
          border: `1px solid ${withAlpha(colorTokens.text.inverse, 0.12)}`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          p: 3,
        }}
      >
        <DarkTypography level="h3" colorVariant="title">
          Chargement
        </DarkTypography>
        <CircularProgress />
      </Box>
    </Modal>
  );
}
